import * as React from "react";
import { useCallback } from "react";
import { TableCell } from "@mzc-pdc/ui";
import { Grid } from "@mui/material";
import Skeleton from "@components_v2/skeleton/skeleton";

export const SkeletonContentsTable = ({ columns }) => {
    const getSkeletonByColumn = useCallback(
        (column) => {
            const { id: columnId, style } = column;
            if (!columnId) return;
            if (columnId === "desiredStatus")
                return <Skeleton variant="rounded" animation={"wave"} width={32} height={18} sx={{ mx: 1.5 }} />;
            if (columnId === "name")
                return (
                    <Grid
                        container
                        direction={`row`}
                        justifyContent={`flex-start`}
                        alignItems={`center`}
                        flexWrap={"nowrap"}
                    >
                        <Grid item>
                            <Skeleton
                                variant="rounded"
                                animation={"wave"}
                                width={52}
                                height={52}
                                sx={{ ml: 1, mr: 1.5 }}
                            />
                        </Grid>
                        <Grid item flex={1}>
                            <Skeleton variant="rounded" animation={"wave"} width={"100%"} height={21} />
                        </Grid>
                    </Grid>
                );
            if (columnId === "duration")
                return <Skeleton variant="rounded" animation={"wave"} width={100} height={18} />;

            return <Skeleton variant="rounded" animation={"wave"} width={style?.custom?.width ?? 100} height={18} />;
        },
        [columns],
    );

    return (
        <>
            <TableCell sx={{ width: "30px" }} padding="checkbox">
                <Grid item>
                    <Skeleton variant="rounded" animation={"wave"} width={18} height={18} />
                </Grid>
            </TableCell>
            {columns &&
                columns.map((column) => (
                    <TableCell
                        key={column.id}
                        mt={1}
                        mb={1}
                        sx={{
                            width: column.style?.custom?.width,
                        }}
                    >
                        {getSkeletonByColumn(column)}
                    </TableCell>
                ))}
        </>
    );
};

export default SkeletonContentsTable;
